module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_comment.9c6ba.png";